(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["du-scroll-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('du-scroll-products')) {
  customElements.define('du-scroll-products', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.setAttribute('data-ready', '');
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadMore();
      }, { rootMargin: '0px 0px 250px 0px' });
      this.observer.observe(this.querySelector('[data-footer]'));
      this.addEventListener('click', event => {
        if (event.target.closest('[data-next]')) {
          event.preventDefault();
          this.loadMore();
        }
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async loadMore() {
      const next = this.querySelector('[data-next]');
      if (!next || this.busy) return;
      this.busy = true;
      this.removeAttribute('data-error');
      const status = this.querySelector('[data-status]');
      status.textContent = this.querySelector('[data-loading]').textContent;
      try {
        const url = new URL(next.href, location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load products');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = Array.from(doc.querySelectorAll('du-scroll-products')).find(el => el.dataset.key === this.dataset.key);
        if (!incoming) throw new Error('Missing product list');
        const grid = this.querySelector('[data-grid]');
        const known = new Set(Array.from(grid.children).map(el => el.dataset.product));
        const cards = Array.from(incoming.querySelector('[data-grid]').children).filter(el => !known.has(el.dataset.product));
        grid.append(...cards);
        const following = incoming.querySelector('[data-next]');
        if (following && following.href !== next.href && cards.length) next.href = following.href;
        else { next.remove(); this.observer.disconnect(); }
        this.observer.unobserve(this.querySelector('[data-footer]'));
        if (following && cards.length) this.observer.observe(this.querySelector('[data-footer]'));
      } catch {
        this.setAttribute('data-error', '');
        this.observer.disconnect();
      } finally {
        status.textContent = '';
        this.busy = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
